import * as React from "react";

import { Box, makeStyles, Theme, Typography } from "@material-ui/core";

interface IProps {
  heading: React.ReactNode;
  subHeading?: React.ReactNode;
  form: React.ReactNode;
}

const useStyles = makeStyles((theme: Theme) => ({
  heading: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: `${32 / 16}rem`,
  },
}));

export const BaseConversationalLayout: React.FC<IProps> = ({
  heading,
  subHeading,
  form,
}) => {
  const classes = useStyles();
  return (
    <Box pt={4} pl={4} pr={4}>
      <Box mb={4}>
        <Typography variant="h5" className={classes.heading}>
          {heading}
        </Typography>
        {subHeading && (
          <Box mt={1}>
            <Typography variant="body2">{subHeading}</Typography>
          </Box>
        )}
      </Box>
      <Box alignItems="center">{form}</Box>
    </Box>
  );
};
